import React from 'react';
import _, { size } from 'lodash';
import { Header, Segment, Button, Icon, Dimmer, Loader, Table } from 'semantic-ui-react';
import { ChartProp } from '../../enum/apiResultProp/ChartProp';
import AbstractChart from './AbstractChart';
import GridFilterPopupForm from '../dataGrid/filter/GridFilterPopupForm';
import AbstractButton from '../form/formButton/button/AbstractButton';
import { FilterConfigProp } from '../../enum/dataGrid/filter/FilterConfigProp';
import { FilterProp } from '../../enum/dataGrid/filter/FilterProp';
import { STRINGS } from '../../helpers/strings';
import { getValue } from '../../helpers/functions';
import GridActions from '../dataGrid/header/GridActions';
import { DataGridProp } from '../../enum/dataGrid/DataGridProp';

export default ({
    screenComponentProps,
    onApplyFiltersClick,
    onDeleteAllFiltersClick,
    onDeleteAppliedFilterRowClick,
    onDeleteNotAppliedFilterRowClick,
    onCreateRowClick,
    onFilterColumnFieldChange,
    onFilterComparatorFieldChange,
    onFilterValueFieldChange,
    clearAllNotAppliedEmptyFilters,
    openModalForm,
    onButtonClickMutateComponentWithPostData,
    reloadScreenWithPostDataOnButtonClick,
    translations,
}) => {

    const title = screenComponentProps[ChartProp.Title];
    const buttons = screenComponentProps[ChartProp.Buttons];
    let columns = screenComponentProps[DataGridProp.Columns];
    const filterConfig = screenComponentProps[DataGridProp.FilterConfig];
    const filters = screenComponentProps[DataGridProp.Filters];
    const appliedFiltersIdsByColumn = screenComponentProps[DataGridProp.AppliedFiltersIds];
    const applyFilersAction = screenComponentProps[DataGridProp.ApplyFilersAction];

    if (!title) {
        return null;
    }

    const renderHeader = () => {
        return (
            <Header style={{ fontSize: '1.7em' }} className='grid-blue-color' textAlign='center'>{title}</Header>
        );
    }

    const renderBody = () => {
        return (
            <AbstractChart screenComponentProps={screenComponentProps} />
        );
    }

    const renderButtons = () => {
        return (
            <Table basic='very'>
                <Table.Body>
                    <GridActions
                        buttons={buttons}
                        filterConfig={filterConfig}
                        filters={filters}
                        appliedFiltersIdsByColumn={appliedFiltersIdsByColumn}
                        onApplyFiltersClick={() => onApplyFiltersClick({ ...applyFilersAction })}
                        onDeleteAllFiltersClick={() => onDeleteAllFiltersClick({ ...applyFilersAction })}
                        onDeleteAppliedFilterRowClick={(params) => onDeleteAppliedFilterRowClick({ ...params, ...applyFilersAction })}
                        onDeleteNotAppliedFilterRowClick={onDeleteNotAppliedFilterRowClick}
                        onCreateRowClick={onCreateRowClick}
                        onFilterColumnFieldChange={onFilterColumnFieldChange}
                        onFilterComparatorFieldChange={onFilterComparatorFieldChange}
                        onFilterValueFieldChange={onFilterValueFieldChange}
                        clearAllNotAppliedEmptyFilters={clearAllNotAppliedEmptyFilters}
                        onButtonClickMutateComponentWithPostData={onButtonClickMutateComponentWithPostData}
                        reloadScreenWithPostDataOnButtonClick={reloadScreenWithPostDataOnButtonClick}
                        translations={translations}
                    />
                </Table.Body>
            </Table>
        );
    }


    //TODO
    {/* <Dimmer active={loaderIsActive} inverted>
                <Loader size='large'>{loaderMessage}</Loader>
            </Dimmer> */}

    return (
        <Segment>
            {renderHeader()}
            {renderButtons()}
            {renderBody()}
        </Segment>
    );
}